<template>
    <v-container class="fill-height" fluid>
        <v-row class="d-flex" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" flat>
                <v-toolbar-title>Login Panel</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form action="#" v-on:submit.prevent="login()" ref="form_login" lazy-loading>
                  <v-text-field 
                    label="Email" 
                    v-model="email" 
                    prepend-icon="mdi-account" 
                    type="text"
                    :rules="this.rules.email"
                    ref="email"
                    v-focus
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    v-model="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    :rules="this.rules.not_empty"
                  />

                  <v-alert dense type="error" v-if="error_message">
                    Sorry, wrong <strong>email</strong> and <strong>password</strong> combination
                  </v-alert>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" type="submit" :disabled="submit_disabled">Login</v-btn>
                  <!-- <v-btn @click="ping()" color="error" type="button">Ping</v-btn> -->
                </v-card-actions>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
    </v-container>
</template>
<script>
    /* eslint-disable */
    import rules from "@/plugins/validation_rules.js";
    export default{
      name:'login.index',
        data:()=>{
          return {
            email:"",
            password:"",
            rules:rules,
            submit_disabled:false,
            error_message:false
          }  
        },
        methods:{
            login: async function(){
                if(this.$refs.form_login.validate()){
                  this.submit_disabled=true;                
                  this.payload = {
                    email:this.email,
                    password:this.password
                  }
  
                  await this.$store.dispatch('AUTH',this.payload)
                  .then(response=>{
                    this.submit_disabled=false;
                    if(!response.error){
                      this.$router.push('dashboard');
                      this.$cookies.set('jwt',response);
                    }else{
                      this.error_message=true;
                    }
                  })  
                }
            },
        },
        mounted:()=>{
          
        }
    }
</script>